export default "__VITE_ASSET__Bgbz3E6I__"